/**
 * Chip Card Payment Monitoring Script
 * Logs payment-related events for diagnostics using console.warn for visibility
 */

(function() {
    'use strict';

    const PAYMENT_MONITOR_PREFIX = '[PaymentMonitoring:ChipCard] ';

    function logPaymentEvent(eventType, details) {
        const message = PAYMENT_MONITOR_PREFIX + eventType + ' | ' + JSON.stringify(details);
        console.warn(message);
    }

    function logIframeEvent(event, details) {
        logPaymentEvent('IFRAME_' + event.toUpperCase(), details);
    }

    window.chipCardPaymentMonitoring = {
        logPaymentEvent,
        logIframeEvent
    };

})();

$(document).ready(function () {
    const $isChipCardFailure = $('input[name="isChipCardFailurePayment"]');
    if ($isChipCardFailure.val() === 'true') {
        if (window.chipCardPaymentMonitoring) {
            window.chipCardPaymentMonitoring.logPaymentEvent('PAYMENT_FAILURE', {
                paymentMethod: 'ChipCard',
                reason: 'session_attribute_detected'
            });
        }
        $('.payment-cancelled-notice').removeClass('hide');
    }
});